import React, {
    createContext,
    useEffect,
    useState
} from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

export const ExperimentCtx = createContext();

const buildExperimentEvaluations = (experiments) => {
    const evaluations = {};
    experiments.forEach(({
        id, value
    }) => {
        evaluations[id] = value;
    });
    return evaluations;
};

export function ExperimentContext(props) {
    const {
        experiments,
        children,
        hydrationComplete
    } = props;

    const [experimentEvaluations, setExperimentEvaluations] = useState({});

    useEffect(() => {
        if (hydrationComplete) {
            setExperimentEvaluations(buildExperimentEvaluations(experiments));
        }
    }, [hydrationComplete, experiments]);

    const isBucketed = (experimentId) => experimentEvaluations[experimentId];
    // defaults to control when not bucketed
    const getVariant = (experimentId) => experimentEvaluations[experimentId] || 0;

    return (
        <ExperimentCtx.Provider value={{
            isBucketed,
            getVariant,
            experimentEvaluations
        }}
        >
            {children}
        </ExperimentCtx.Provider>
    );
}

ExperimentContext.propTypes = {
    experiments: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.number.isRequired,
        value: PropTypes.number.isRequired
    })).isRequired,
    children: PropTypes.node.isRequired,
    hydrationComplete: PropTypes.bool.isRequired
};

/* istanbul ignore next */
const mapStateToProps = (state) => {
    const { app: { experiments }, hydration } = state;
    const { hydrationComplete } = hydration;
    return {
        experiments,
        hydrationComplete
    };
};

export default connect(mapStateToProps)(ExperimentContext);
